import React, { useEffect } from "react";
import Meta from "./../components/Meta";
import VideoLaunchBanner from "./../components/VideoLaunchBanner";
import HeroSection from "./../components/HeroSection";
import HeroSection2 from "./../components/HeroSection2";
import HeroSection3 from "./../components/HeroSection3";
import ImageShowcase from "./../components/ImageShowcase";
import FaqSection from "./../components/FaqSection";
import { AgeVerification } from "../components/AgeVerification";
import { useAuth } from "../util/auth";
import { Link } from "./../util/router";

function IndexPage(props) {
  const ageVerified = localStorage.getItem("ageVerified");
  const auth = useAuth();
  const refId = localStorage.getItem("tap_ref");

  useEffect(() => {
    if (auth?.user) {
      fetch("/api/createCustomer", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Ref-Id": refId || "", // Sending refId in headers
        },
        body: JSON.stringify({
          email: auth.user.email,
          name: auth.user.displayName,
        }),
      })
        .then((res) => res.json())
        .then((data) => console.log("Customer created:", data))
        .catch((err) => console.error("Error creating customer:", err));
    } else {
      console.log("notrunninfff");
    }
  }, [auth.user]);

  return (
    <>
      <Meta title="#1 NSFW AI Art Generator - Create AI Art Free" />
      {ageVerified !== "true" && <AgeVerification />}

      <VideoLaunchBanner />

      <HeroSection
        bgColor="default"
        size="large"
        bgImage=""
        bgImageOpacity={1}
        title="#1 NSFW AI Generator"
        smallTitle="Bring Your Wildest Fantasies “REAL” with this Erotic, NSFW AI Generator"
        subtitle="Try our NSFW AI Art Generator to turn your fantasies into explicit artwork. Give us your prompt, and our AI will create personalized, detailed art based on your desires. Experience art in a new way and explore your fantasies visually."
        buttonText="Get Started"
        buttonColor="primary"
        buttonPath="/create"
      />
      <ImageShowcase />
      <HeroSection2
        bgColor="default"
        size="medium"
        bgImage=""
        bgImageOpacity={1}
        icon="🎨"
        title="Diverse Styles"
        subtitle="Our NSFW AI Art Generator allows you to create a variety of bold art styles, from anime to realistic images. Just click to explore different art styles that interest you. Use our NSFW Art Generator to find the art that matches your imagination."
        image="/cloudImages/homepage-image1.png"
      />
      <HeroSection3
        bgColor="default"
        size="medium"
        bgImage=""
        bgImageOpacity={1}
        icon="🔥"
        title="Explicit Poses"
        subtitle="Our collection includes a wide range of explicit poses, from POV BlowJob to POV Spit Roast, covering various perspectives to provide a fully immersive experience. Whatever your preference, we have it covered."
        image="/cloudImages/homepage-image2.png"
      />
      <HeroSection2
        bgColor="default"
        size="medium"
        bgImage=""
        bgImageOpacity={1}
        icon="🔒"
        title="Privacy First"
        subtitle="Create NSFW art privately. Your fantasies stay secure and confidential with our discreet process, respecting your personal space."
        image="/cloudImages/homepage-image3.png"
      />
      <HeroSection3
        bgColor="default"
        size="medium"
        bgImage=""
        bgImageOpacity={1}
        icon="⚡"
        title="FREE, Fast & Reliable"
        subtitle="You can generate up to 2 images for FREE with our NSFW AI Image Generator. We use the fastest server available that results in fast generation of NSFW Images. The images are kept in a highly secured environment."
        image="/cloudImages/homepage-image2.png"
      />

      <HeroSection3
        bgColor="default"
        size="medium"
        icon="💜"
        title="Why Choose Our NSFW Art Generator?"
        subtitle="Ready to dive into the endless excitement of AI NSFW art? Try our NSFW AI art generator today! It turns text into NSFW AI art in no time. There’s nothing it can’t create. Let it spark your creativity!"
        image="/cloudImages/homepage-image2.png"
      />

      {/* ── POPULAR GENERATORS ── */}
      <section className="py-16 px-4">
        <div className="mx-auto max-w-6xl">
          <h2 className="mb-8 text-center text-xl font-black text-foreground/80">Popular AI Generators</h2>
          <div className="grid gap-5 sm:grid-cols-3">
            <Link
              to="/create/ai-boobs"
              className="group relative block aspect-[4/5] overflow-hidden rounded-2xl border border-white/10 bg-white/5 shadow-2xl transition duration-500 hover:-translate-y-1 hover:border-pink-500/50"
            >
              <img
                src="/boobs-1.png"
                alt=""
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 flex flex-col items-center gap-1 p-6 text-center">
                <div className="text-3xl">🍒</div>
                <div className="font-bold text-white transition group-hover:text-pink-300">AI Boobs Generator</div>
                <div className="text-xs text-white/70">Realistic &amp; anime bust images in seconds</div>
              </div>
            </Link>
            <Link
              to="/create/ai-blowjob-generator"
              className="group relative block aspect-[4/5] overflow-hidden rounded-2xl border border-white/10 bg-white/5 shadow-2xl transition duration-500 hover:-translate-y-1 hover:border-rose-500/50"
            >
              <img
                src="/anime-3.png"
                alt=""
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 flex flex-col items-center gap-1 p-6 text-center">
                <div className="text-3xl">💋</div>
                <div className="font-bold text-white transition group-hover:text-rose-300">AI Blowjob Generator</div>
                <div className="text-xs text-white/70">Photorealistic adult scenes, any style</div>
              </div>
            </Link>
            <Link
              to="/ai-nude"
              className="group relative block aspect-[4/5] overflow-hidden rounded-2xl border border-white/10 bg-white/5 shadow-2xl transition duration-500 hover:-translate-y-1 hover:border-purple-500/50"
            >
              <img
                src="/fr-1.png"
                alt=""
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 flex flex-col items-center gap-1 p-6 text-center">
                <div className="text-3xl">🔥</div>
                <div className="font-bold text-white transition group-hover:text-purple-300">AI Nude Generator</div>
                <div className="text-xs text-white/70">Full nude AI art — realistic, anime, fantasy</div>
              </div>
            </Link>
          </div>
        </div>
      </section>

      <FaqSection
        bgColor="default"
        size="medium"
        bgImage=""
        bgImageOpacity={1}
        title="Frequently Asked Questions"
        subtitle=""
      />
    </>
  );
}

export default IndexPage;
